/**
 * Voice API — server-side voice notes (ported from the legacy frontend).
 *
 * Records browser audio and uploads it to POST /voice/note, where the backend
 * transcribes it (Gemini) and runs the full capture pipeline. This is more
 * accurate than the browser SpeechRecognition path (useVoiceInput), which only
 * produces text client-side.
 */
import { apiClient, getAuthHeaders } from './client';

export interface VoiceNoteResponse {
  tasks_extracted?: number;
  tasks_merged?: number;
  summary?: string;
  connections?: unknown[];
  item_id?: string;
  [key: string]: unknown;
}

/** Upload a recorded audio blob to the backend voice-note pipeline. */
export async function voiceNote(
  audio: Blob,
  filename = 'voice-note.webm',
): Promise<VoiceNoteResponse> {
  const form = new FormData();
  form.append('file', audio, filename);

  const baseURL = (apiClient as unknown as { baseURL?: string }).baseURL || '';
  // Auth header only (no Content-Type — the browser sets the multipart boundary).
  const headers = await getAuthHeaders();

  const res = await fetch(`${baseURL}/voice/note`, {
    method: 'POST',
    body: form,
    headers,
  });

  if (!res.ok) {
    let message = 'Voice note upload failed.';
    try {
      const body = await res.json();
      message = (body && (
        (body.message as string) ||
        (body.detail && (body.detail.message as string))
      )) || message;
    } catch {
      /* ignore non-JSON error bodies */
    }
    throw new Error(message);
  }
  return res.json();
}
